import { FunctionToArgRecord } from '@clearverify/types';

import { INBOX_FILTER_FUNCTION_MAPPING } from './constants';

export const InboxFilterFormFields = {
  statuses: 'statuses',
  dateCreated: 'dateCreated',
  employee: 'employee',
  employer: 'employer',
  verifier: 'verifier',
  verificationRequestTypes: 'verificationRequestTypes',
  verifierType: 'verifierType',
  peo: 'peo',
} as const satisfies Record<string, string>;

export interface InboxFilterFieldProps {
  disabled?: boolean;
}

export type InboxFilterFormValues = Partial<
  FunctionToArgRecord<typeof INBOX_FILTER_FUNCTION_MAPPING>
>;
